(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumaaura-cart-drawer-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lumaaura-cart-tracker')) {
        customElements.define('lumaaura-cart-tracker', class extends HTMLElement {
          connectedCallback() {
            this.currencyRetryCount = 0;
            this.updateShippingTracker();
            this.updateTimer();
            this.timer = window.setInterval(() => this.updateTimer(), 1000);
            this.drawer = this.closest('theme-drawer');
            this.drawer?.addEventListener('theme-drawer:open', this.animateProgress);
            if (this.drawer?.hasAttribute('open')) this.animateProgress();
          }

          disconnectedCallback() {
            window.clearInterval(this.timer);
            window.clearTimeout(this.currencyRetry);
            window.clearTimeout(this.progressAnimationTimer);
            this.drawer?.removeEventListener('theme-drawer:open', this.animateProgress);
          }

          animateProgress = () => {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

            const targetProgress = this.style.getPropertyValue('--tracker-progress');
            const targetProgressScale = this.style.getPropertyValue('--tracker-progress-scale');
            if (!targetProgress) return;

            window.clearTimeout(this.progressAnimationTimer);
            this.classList.remove('is-progress-animating');
            this.style.setProperty('--tracker-progress', '0%');
            this.style.setProperty('--tracker-progress-scale', '0');

            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                this.classList.add('is-progress-animating');
                this.style.setProperty('--tracker-progress', targetProgress);
                this.style.setProperty('--tracker-progress-scale', targetProgressScale || '0');
                this.progressAnimationTimer = window.setTimeout(() => {
                  this.classList.remove('is-progress-animating');
                }, 900);
              });
            });
          };

          updateShippingTracker() {
            const baseThreshold = Number(this.dataset.baseThreshold);
            const fallbackThreshold = Number(this.dataset.fallbackThreshold);
            const cartTotal = Number(this.dataset.cartTotal);
            const cartCurrency = this.dataset.cartCurrency || 'USD';
            const baseCurrency = this.dataset.baseCurrency || 'USD';
            let rate = 1;
            let activeThreshold = baseThreshold;

            if (cartCurrency !== baseCurrency) {
              const marketRate = Number(window.Shopify?.currency?.rate);
              if (Number.isFinite(marketRate) && marketRate > 0 && Math.abs(marketRate - 1) > 0.0001) {
                rate = marketRate;
                activeThreshold = Math.round(baseThreshold * rate);
              } else if (Number.isFinite(fallbackThreshold) && fallbackThreshold > 0) {
                activeThreshold = fallbackThreshold;
              }

              if (
                (!Number.isFinite(marketRate) || Math.abs(marketRate - 1) <= 0.0001) &&
                !this.currencyRetry &&
                this.currencyRetryCount < 8
              ) {
                this.currencyRetryCount += 1;
                this.currencyRetry = window.setTimeout(() => {
                  this.currencyRetry = null;
                  this.updateShippingTracker();
                }, 500);
              }
            }

            if (!Number.isFinite(baseThreshold) || baseThreshold <= 0 || !Number.isFinite(cartTotal)) return;
            if (!Number.isFinite(activeThreshold) || activeThreshold <= 0) return;

            const remaining = Math.max(0, activeThreshold - cartTotal);
            const progress = Math.min(100, Math.max(0, (cartTotal / activeThreshold) * 100));
            const progressBar = this.querySelector('[data-shipping-progress]');
            const message = this.querySelector('[data-shipping-message]');

            this.style.setProperty('--tracker-progress', `${progress}%`);
            this.style.setProperty('--tracker-progress-scale', String(progress / 100));
            progressBar?.setAttribute('aria-valuenow', String(Math.round(progress)));

            if (!message) return;
            if (remaining <= 0) {
              const strong = document.createElement('strong');
              strong.textContent = this.dataset.shippingUnlockedText || "You've unlocked free shipping!";
              message.replaceChildren(strong);
              return;
            }

            const template = this.dataset.shippingRemainingTemplate || 'Add [amount] more to unlock free shipping!';
            const parts = template.split('[amount]');
            if (parts.length === 1) {
              message.textContent = template;
              return;
            }

            const fragment = document.createDocumentFragment();
            parts.forEach((part, index) => {
              fragment.append(document.createTextNode(part));
              if (index < parts.length - 1) {
                const strong = document.createElement('strong');
                strong.textContent = this.formatMoney(remaining, cartCurrency);
                fragment.append(strong);
              }
            });
            message.replaceChildren(fragment);
          }

          formatMoney(cents, currency) {
            const locale = window.Shopify?.locale || document.documentElement.lang || 'en';
            try {
              return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency,
                currencyDisplay: 'narrowSymbol'
              }).format(cents / 100);
            } catch (error) {
              return `${(cents / 100).toFixed(2)} ${currency}`;
            }
          }

          updateTimer() {
            const output = this.querySelector('[data-midnight-timer]');
            if (!output) return;
            const now = new Date();
            const countdownHour = Math.min(23, Math.max(0, Number(this.dataset.countdownHour) || 0));
            const countdownMinute = Math.min(59, Math.max(0, Number(this.dataset.countdownMinute) || 0));
            const countdownEnd = new Date(now);
            countdownEnd.setHours(countdownHour, countdownMinute, 0, 0);
            if (countdownEnd <= now) countdownEnd.setDate(countdownEnd.getDate() + 1);
            const remaining = Math.max(0, countdownEnd.getTime() - now.getTime());
            const hours = Math.floor(remaining / 3600000);
            const minutes = Math.floor((remaining % 3600000) / 60000);
            const seconds = Math.floor((remaining % 60000) / 1000);
            output.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
          }
        });
      }

      if (!customElements.get('lumaaura-cart-upsell-card')) {
        customElements.define('lumaaura-cart-upsell-card', class extends HTMLElement {
          connectedCallback() {
            this.addEventListener('change', this.handleVariantChange);
          }

          disconnectedCallback() {
            this.removeEventListener('change', this.handleVariantChange);
          }

          handleVariantChange = () => {
            const variantData = this.querySelector('[data-variant-json]');
            const variantInput = this.querySelector('[ref="variantId"]');
            const addButton = this.querySelector('[data-upsell-add]');
            if (!variantData || !variantInput || !addButton) return;

            const selectedOptions = Array.from(this.querySelectorAll('[data-option-index]')).map((select) => select.value);
            const variants = JSON.parse(variantData.textContent || '[]');
            const selectedVariant = variants.find((variant) => variant.options.every((option, index) => option === selectedOptions[index]));

            if (!selectedVariant) {
              addButton.disabled = true;
              addButton.textContent = 'Unavailable';
              return;
            }

            variantInput.value = selectedVariant.id;
            addButton.disabled = !selectedVariant.available;
            addButton.textContent = selectedVariant.available ? 'Add' : 'Sold Out';
          };
        });
      }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lumaaura-size-chart-trigger"] && !Shopify.designMode) return;
  try {
    if (document.documentElement.dataset.lumaauraSizeChartDelegation !== 'true') {
    document.documentElement.dataset.lumaauraSizeChartDelegation = 'true';

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const openButton = event.target.closest('[data-lumaaura-size-chart-open]');
      if (openButton) {
        const picker = openButton.closest('variant-picker');
        const dialogId = openButton.dataset.lumaauraSizeChartOpen;
        const dialog = picker?.querySelector('[data-lumaaura-size-chart-dialog]') ?? document.getElementById(dialogId);
        if (!(dialog instanceof HTMLDialogElement)) return;

        event.preventDefault();
        if (!dialog.open) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-lumaaura-size-chart-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-lumaaura-size-chart-dialog]');
        if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
        return;
      }

      if (event.target.matches('[data-lumaaura-size-chart-dialog]') && event.target.open) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
